import type { SupportedLocale } from "../../config/locales";

import { supported_locales_keys } from "../../config/locales";

export function localeToLang(locale: string): string {
  return locale.slice(0, 2);
}

export function getFallbackLocales(
  searched_locale: SupportedLocale
): SupportedLocale[] {
  const searched_lang = localeToLang(searched_locale);

  return supported_locales_keys
    .filter(locale => {
      if (locale === searched_locale) {
        return false;
      }
      const lang = localeToLang(locale);
      if (lang === searched_lang) {
        return true;
      }
    })
    .sort((a, b) => {
      return a.length - b.length;
    });
}
